/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_BakeryInputs */

const en_store_bakery = /** @type {(inputs: Store_BakeryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bakery`)
};

const de_store_bakery = /** @type {(inputs: Store_BakeryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backwaren`)
};

/**
* | output |
* | --- |
* | "Bakery" |
*
* @param {Store_BakeryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const store_bakery = /** @type {((inputs?: Store_BakeryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_BakeryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_store_bakery(inputs)
	return en_store_bakery(inputs)
});